/**
 * 레티나 헤어라인 mixin.
 *
 * 0.5px `border` 는 박스 변이 물리 픽셀 격자의 정수 위치에 떨어지면 보이지만,
 * 픽셀 사이(분수 위치)에 떨어지면 안티에일리어싱으로 두 줄에 절반씩 퍼져 거의
 * 투명해진다(특히 일부 모바일 webview). 박스마다 화면상 절대 Y 위치가 달라
 * "특정 박스만 하단 변이 사라지는" 증상이 난다(겹침·간격과 무관, 순전히 위치×DPR).
 *
 * 이 mixin 은 1px 테두리를 2배 크기 ::after 가상요소에 그린 뒤 scale(0.5) 로
 * 축소한다. 선이 박스의 분수 위치가 아니라 정수 픽셀 geometry 에서 래스터되므로,
 * 위치와 무관하게 시각적 0.5px 헤어라인을 안정적으로 렌더한다.
 *
 * 사용처 요소는 `border` 를 직접 주지 않는다 — 이 mixin 이 position: relative 와
 * ::after 를 함께 제공한다. 배경 모서리용 `border-radius` 는 요소에 그대로 두고,
 * 같은 값을 radius 인자로 넘긴다(가상요소는 2배로 그린 뒤 축소되므로 내부에서 2배 처리).
 */
export const hairlineBorder = (color: string, radius = 4) => `
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    box-sizing: border-box;
    border: 1px solid ${color};
    border-radius: ${radius * 2}px;
    transform: scale(0.5);
    transform-origin: 0 0;
    pointer-events: none;
  }
`
